var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseElSelect',_vm._b({model:{value:(_vm.syncValue),callback:function ($$v) {_vm.syncValue=$$v},expression:"syncValue"}},'BaseElSelect',_vm.$attrs,false),_vm._l((_vm.displayOptions),function(options){return _c('BaseElSelectOption',{key:options.value,attrs:{"value":options.value,"label":options.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }